/*

  # Responsive background image controller

  The `div[data-type="bgImage"]` setting attributes are:

  - `data-handler`, a URL with replaceable keywords of `{width}` and `{height}`.
  - `data-roundingwidths`, which specifies a set of rounding widths,
     which are arrays referenced by property name on `roundingWidthSets`.
     When omitted, the requested size does not round widths.
  <div data-hook="bgImage"
    data-handler="./assets/image.jpg?width={width}&amp;height={height}"
    data-roundingwidths="standard">

*/

import {
  assignController,
} from '../api/element-manipulation'

import { roundingWidthSets, getImageSizeURL, isImageSizeComputable } from '../api/image-calculations'

assignController('bgImage', (element) => {
  let oldWidth = 0
  let oldHeight = 0
  let hasComputedImage = false
  let roundingWidths = element.dataset.roundingwidths
  const isToRound = !!roundingWidths
  if (isToRound) {
    roundingWidths = roundingWidthSets[roundingWidths]
  }

  const apply = () => {
    if ( !isImageSizeComputable(element) || !element.dataset.handler ) {
      return
    }
    element.style.backgroundImage = `url(${ getImageSizeURL( {
      width: element.offsetWidth,
      height: element.offsetHeight,
      roundingWidths,
      src: element.dataset.handler,
    }) })`
    hasComputedImage = true
  }

  window.addEventListener('resize', (e) => {
    const newWidth = window.innerWidth
    const newHeight = window.innerHeight
    if ( hasComputedImage ) {
      if ( (Math.abs(newHeight - oldHeight) < 100) && (Math.abs(newWidth - oldWidth) < 100) ) {
        return
      }
    }
    oldWidth = newWidth
    oldHeight = newHeight
    apply()
  })

  apply()

  return {
    apply,
  }
})

